export enum ButtonSize {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
}

export enum ButtonView {
    DEFAULT = 'DEFAULT',
    ACTION = 'ACTION',
}

export enum ButtonStyling {
    CELL = 'CELL',
    FILLED = 'FILLED',
    TRANSPARENT = 'TRANSPARENT',
}

export enum ButtonType {
    SUBMIT = 'SUBMIT',
    BUTTON = 'BUTTON',
    RESET = 'RESET',
}

type ButtonInputType = 'submit' | 'button' | 'reset';

export const mapSizeToClassname: { [key in ButtonSize]: string } = {
    [ButtonSize.SMALL]: 'button--sm',
    [ButtonSize.MEDIUM]: 'button--size-m',
};

export const mapViewToClassname: { [key in ButtonView]: string } = {
    [ButtonView.DEFAULT]: '',
    [ButtonView.ACTION]: 'button--action',
};

export const mapStylingToClassname: { [key in ButtonStyling]: string } = {
    [ButtonStyling.CELL]: 'button--cell',
    [ButtonStyling.FILLED]: 'button--filled',
    [ButtonStyling.TRANSPARENT]: 'button--transparent',
};

export const mapTypeToButtonType: { [key in ButtonType]: ButtonInputType } = {
    [ButtonType.BUTTON]: 'button',
    [ButtonType.SUBMIT]: 'submit',
    [ButtonType.RESET]: 'reset',
};
